import { useState } from "react";
import type { ColumnContext } from "./CalendarBoard.tsx";
import { timeLabel } from "./layout.ts";

/**
 * A day of the calendar while a level is picked: the whole day is a button, a dashed block follows
 * the pointer with the time it would start, and a click adds the level there. A keyboard press has
 * no position, so it adds at the day's usual afternoon start, 4:00 PM. Both views of the Schedule page
 * add this way: a weekly time on the timetable, one session on the week of sessions.
 */
export function AddLayer({
  label,
  length,
  name,
  context,
  onAdd,
}: {
  /** The accessible name: "Add Golden team on Saturday". */
  label: string;
  /** Minutes the new block takes. */
  length: number;
  /** The words in the dashed block after the time: "Golden team". */
  name: string;
  context: ColumnContext;
  onAdd: (minute: number) => void;
}) {
  const [hover, setHover] = useState<number | null>(null);
  const { perMinute, range, minuteAt } = context;
  return (
    <>
      <button
        type="button"
        aria-label={label}
        className="absolute inset-0 z-0 cursor-copy"
        onPointerMove={(event) => {
          const rect = event.currentTarget.getBoundingClientRect();
          setHover(minuteAt(event.clientY, rect.top, length));
        }}
        onPointerLeave={() => setHover(null)}
        onClick={(event) => {
          if (event.detail === 0) {
            onAdd(16 * 60);
            return;
          }
          const rect = event.currentTarget.getBoundingClientRect();
          onAdd(minuteAt(event.clientY, rect.top, length));
        }}
      />
      {hover !== null ? (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute z-10 rounded-lg border-[1.5px] border-dashed border-accent bg-accent-surface/70 px-1.5 py-0.5 text-[11px] font-semibold text-accent-strong"
          style={{ top: (hover - range.start) * perMinute + 1, height: length * perMinute - 2, left: 3, right: 3 }}
        >
          {timeLabel(hover)} {name}
        </span>
      ) : null}
    </>
  );
}
